// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"coins-table_actionsWrapper__6uIun","addSymbol":"coins-table_addSymbol__pBh3a"};